import * as yup from 'yup';
import { generateYupValidationSchema } from '@center-platform/spheres/validation';
import type { SchemaProperty } from 'types/schema';

/**
 * The Sphere Editor form's validation schema. A hidden property renders no field, so an error on it
 * could neither be shown nor fixed and would block Save on a value the person cannot see (for example
 * a legacy malformed `glyph_color`). Hidden properties are left out; the server still validates them
 * on every write.
 */
export function editorValidationSchema(properties: SchemaProperty[]) {
  const visible = properties.filter((property) => !property.hidden);
  return yup.object({
    properties: yup.object(generateYupValidationSchema(visible)),
  });
}
